import * as actionType from "./BudgetAction";

const initialState = {
  list: [],
  message: "",
  modalOpen: false,
  loading: false,
  isBudgetEdit: false,
  isBudgetList: true,
  apiStatus: false,
};
const BudgetReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GET_ALL_MAIN_CATEGORY_DATA:
      return {
        ...state,
        loading: false,
        modalOpen: false,
        isBudgetList: true,
        isBudgetEdit: false,
        isAssetCreate: false,
        message: "",
        AllData: action.payload,
      };
      case actionType.GET_LOAD_BUDGET_SOM_DATA:
        return{
          ...state,
          loading:false,
          modalOpen:false,
          isBudgetList: false,
          isBudgetEdit: false,
          isAssetCreate: false,
          message: "",
          BudgetPlannerSM:action.payload,
        }
      case actionType.CLEAR_ALL_DATA:
        return{
          ...state,
          loading:false,
          modalOpen:false,
          isBudgetList: false,
          isBudgetEdit: false,
          isAssetCreate: false,
          message: "",
          BudgetPlannerSM:[],
          StatusInfo:{}
        }
      case actionType.GET_LOAD_REMARKS_FOR_BUDGET:
        return{
          ...state,
          loading:false,
          modalOpen:false,
          isBudgetList: false,
          isBudgetEdit: false,
          isAssetCreate: false,
          message: "",
          RemarksData:action.payload
        }
      case actionType.API_CALL_STATUS:
        return {
          ...state,
          loading:action.payload.loading,
          modalOpen:action.payload.modalOpen,
          message:action.payload.message,
        }
      case actionType.STATUS_UPDATE:
        return {
          ...state,
          loading:false,
          modalOpen:false,
          message:'',
          StatusInfo:action.payload
        }
    default:
      return state;
  }
};
export default BudgetReducer;
